import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from 'src/app/guards/auth.guard';
import { embedAuthGuard } from './guards/embed-auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule),
    canActivate: [authGuard]
  },
  {
    path: 'safe-lift',
    loadChildren: () => import('./pages/safe-lift/safe-lift.module').then( m => m.SafeLiftPageModule),
    canActivate: [authGuard]
  },
  {
    path: 'embed',
    loadChildren: () => import('./pages/embed/embed.module').then( m => m.EmbedPageModule),
    canActivate: [embedAuthGuard]
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
